import { Button, Form, Input, InputNumber, notification, Select, Space, Row, Col, Typography, Divider } from "antd";
import { Department, PaymentModel, ProductType, SalesChannel } from "../../../../dto/model";
import { SlotConfiguration } from "../../../../dto/admin-config-models";

const { Text } = Typography;

type SlotConfigFormProps = {
  onSave: (slotConfig: SlotConfiguration) => void;
  onCancel: (editingId: string | null) => void;
  onDelete: (slotConfig: SlotConfiguration) => void;
  slotConfiguration: SlotConfiguration;
};

export const SlotConfigForm = ({ onSave, onCancel, onDelete, slotConfiguration }: SlotConfigFormProps) => {
  const [form] = Form.useForm<SlotConfiguration>();

  const onFormSave = async () => {
    try {
      const values = await form.validateFields();
      const updatedConfig: SlotConfiguration = {
        ...slotConfiguration,
        ...values
      };
      onSave(updatedConfig);
    } catch (err: any) {
      if (Array.isArray(err.errorFields)) {
        const description = err.errorFields
          .map((f: any) => `${f.name.join('.')}: ${f.errors.join(', ')}`)
          .join('\n');
        notification.error({
          message: 'Validation Failed',
          description
        });
      } else {
        notification.error({
          message: 'Save Failed',
          description: err.message
        });
      }
    }
  };

  const onFormCancel = () => {
    if (slotConfiguration.id <= 0) {
      onDelete(slotConfiguration);
    }

    onCancel(null);
  }

  return (
    <Form form={form} layout="vertical" initialValues={slotConfiguration}>
      <Form.Item
        name="title"
        label="Title"
        rules={[{ required: true }]}
      >
        <Input placeholder="Title" />
      </Form.Item>

      <Divider plain>IF</Divider>
      <Row gutter={16} style={{ marginTop: 8 }}>
        <Col flex="1">
          <Form.Item name="salesLeague" label="Sales League">
            <InputNumber
              min={0}
              placeholder="Sales League"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col flex="1">
          <Form.Item name="salesChannel" label="Sales Channel">
            <Select placeholder="Sales Channel" style={{ width: "100%" }}>
              {Object.values(SalesChannel).map((sc) => (
                <Select.Option value={sc} key={sc}>
                  {sc}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col flex="1">
          <Form.Item name="productType" label="Product Type">
            <Select placeholder="Product Type" style={{ width: "100%" }}>
              {Object.values(ProductType).map((opt) => (
                <Select.Option value={opt} key={opt}>
                  {opt}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col flex="1">
          <Form.Item name="paymentModel" label="Payment Model">
            <Select placeholder="Payment Model" style={{ width: "100%" }}>
              {Object.values(PaymentModel).map((pm) => (
                <Select.Option value={pm} key={pm}>
                  {pm}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col flex="1">
          <Form.Item name="department" label="Department">
            <Select placeholder="Department" style={{ width: "100%" }}>
              {Object.values(Department).map((key, value) => (
                <Select.Option value={value} key={key}>
                  {key}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Divider plain style={{ marginTop: 24 }}>
        THEN
      </Divider>
      <Form.Item
        name="maxSlotsPerDay"
        label="Max Appointments per Day"
        rules={[{ required: true }]}
      >
        <InputNumber
          min={1}
          placeholder="Max slots"
          style={{ width: "100%" }}
        />
      </Form.Item>

      <Form.Item>
        <Space size="middle">
          <Button type="primary" onClick={onFormSave}>
            Save
          </Button>
          <Button type="default" onClick={onFormCancel}>
            Cancel
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};